export const TIME_DELAY = 5000; // ms - Flash Sale delay
export const SCROLL_DISTANCE = '80vh';
export const IS_LOGGED_IN = false;
export const SHOW_BANNER_CONDITION = () => true;

// Sale-specific timing settings
export const BLACK_FRIDAY_TIME_DELAY = 0; // Show immediately
export const BLACK_FRIDAY_SHOW_ON_SCROLL = false; // No scroll required
export const CYBER_MONDAY_TIME_DELAY = 0; // Show immediately
export const CYBER_MONDAY_SHOW_ON_SCROLL = false; // No scroll required
export const NEW_YEAR_TIME_DELAY = 0; // Show immediately
export const NEW_YEAR_SHOW_ON_SCROLL = false; // No scroll required
export const MEMORIAL_DAY_TIME_DELAY = 0; // Show immediately
export const MEMORIAL_DAY_SHOW_ON_SCROLL = false; // No scroll required
export const LABOR_DAY_TIME_DELAY = 0; // Show immediately
export const LABOR_DAY_SHOW_ON_SCROLL = false; // No scroll required

// Banner text constants
export const COUPON_CODE = 'PE6X5QM';
export const DEAL_TEXT = 'FLASH DEAL';
export const PERCENTAGE = '20%';
export const DISCOUNT_TEXT = `Save ${PERCENTAGE} on ANY plan with code ${COUPON_CODE}`;
export const BUTTON_TEXT = 'Act Now';
export const BUTTON_TEXT_BANNER = 'Act Now: Flash Sale';
export const FLASH_SALE_TEXT = 'Flash Sale';

// Black friday banner text constants
export const BLACK_FRIDAY_COUPON_CODE = 'BF40';
export const BLACK_FRIDAY_DEAL_TEXT = 'BLACK FRIDAY SALE';
export const BLACK_FRIDAY_PERCENTAGE = '40%';
export const BLACK_FRIDAY_DISCOUNT_TEXT = `Save ${BLACK_FRIDAY_PERCENTAGE} on ANY plan with code ${BLACK_FRIDAY_COUPON_CODE}`;
export const BLACK_FRIDAY_BUTTON_TEXT = 'Act Now';
export const BLACK_FRIDAY_BUTTON_TEXT_BANNER = 'Act Now: Black Friday Flash Sale';
export const BLACK_FRIDAY_TARGET_DATE = new Date('2025-12-01T07:59:00Z'); // 11:59 PM PST is 7:59 AM UTC

// Cyber monday banner text constants
export const CYBER_MONDAY_COUPON_CODE = 'CM40';
export const CYBER_MONDAY_DEAL_TEXT = 'CYBER MONDAY SALE';
export const CYBER_MONDAY_PERCENTAGE = '40%';
export const CYBER_MONDAY_DISCOUNT_TEXT = `Save ${CYBER_MONDAY_PERCENTAGE} on ANY plan with code ${CYBER_MONDAY_COUPON_CODE}`;
export const CYBER_MONDAY_BUTTON_TEXT = 'Act Now';
export const CYBER_MONDAY_BUTTON_TEXT_BANNER = 'Act Now: Cyber Monday Flash Sale';
export const CYBER_MONDAY_TARGET_DATE = new Date('2025-12-05T07:59:00Z'); // 11:59 PM PST on Dec 4 is 7:59 AM UTC on Dec 5
// export const CYBER_MONDAY_COUPON_CODE = 'CM10';
// export const CYBER_MONDAY_DEAL_TEXT = 'CYBER MONDAY SALE';
// export const CYBER_MONDAY_PERCENTAGE = '30%';
// export const CYBER_MONDAY_DISCOUNT_TEXT = `$10 First Month (or $65 off ANY plan) with code ${CYBER_MONDAY_COUPON_CODE}`;
// export const CYBER_MONDAY_BUTTON_TEXT = 'Act Now';
// export const CYBER_MONDAY_BUTTON_TEXT_BANNER = 'Act Now: Cyber Monday Flash Sale';
// export const CYBER_MONDAY_TARGET_DATE = new Date('2025-12-05T07:59:00Z'); // 11:59 PM PST on Dec 4 is 7:59 AM UTC on Dec 5

// Memorial Day banner text constants
export const MEMORIAL_DAY_COUPON_CODE = 'MD30';
export const MEMORIAL_DAY_DEAL_TEXT = 'MEMORIAL DAY SALE';
export const MEMORIAL_DAY_PERCENTAGE = '30%';
export const MEMORIAL_DAY_DISCOUNT_TEXT = `Save ${MEMORIAL_DAY_PERCENTAGE} on ANY plan with code ${MEMORIAL_DAY_COUPON_CODE}`;
export const MEMORIAL_DAY_BUTTON_TEXT = 'Act Now';
export const MEMORIAL_DAY_BUTTON_TEXT_BANNER = 'Act Now: Memorial Day Sale';
export const MEMORIAL_DAY_TARGET_DATE = new Date('2026-05-27T07:00:00Z'); // 12:00 AM PDT on May 27 (end of Tue May 26 market day) is 7:00 AM UTC on May 27

// New year banner text constants
export const NEW_YEAR_COUPON_CODE = 'NY30';
export const NEW_YEAR_DEAL_TEXT = 'NEW YEAR SALE';
export const NEW_YEAR_PERCENTAGE = '30%';
export const NEW_YEAR_DISCOUNT_TEXT = `Save ${NEW_YEAR_PERCENTAGE} on ANY plan with code ${NEW_YEAR_COUPON_CODE}`;
export const NEW_YEAR_BUTTON_TEXT = 'Act Now';
export const NEW_YEAR_BUTTON_TEXT_BANNER = 'Act Now: New Year Flash Sale';
export const NEW_YEAR_TARGET_DATE = new Date('2026-01-06T07:59:00Z'); // 11:59 PM PST on Jan 5 is 7:59 AM UTC on Jan 6

// Labor Day banner text constants
export const LABOR_DAY_COUPON_CODE = 'SUMMER30';
export const LABOR_DAY_DEAL_TEXT = 'LABOR DAY SALE';
export const LABOR_DAY_PERCENTAGE = '30%';
export const LABOR_DAY_DISCOUNT_TEXT = `Save ${LABOR_DAY_PERCENTAGE} on ANY plan with code ${LABOR_DAY_COUPON_CODE}`;
export const LABOR_DAY_BUTTON_TEXT = 'Act Now';
export const LABOR_DAY_BUTTON_TEXT_BANNER = 'Act Now: Labor Day Sale';
export const LABOR_DAY_TARGET_DATE = new Date('2026-09-10T07:00:00Z'); // Sep 10, 12:00 AM PDT (sale end) — must match the LABOR_DAY endDate below so the countdown runs to the end, not the start

export const TIME_LEFT = 1 * 24 * 60 * 60 + 11 * 60 * 60 + 24 * 60 + 55; // 1 day + 11 hours + 24 minutes + 55 seconds
export const TARGET_DATE = new Date('2025-11-30T07:59:00Z'); // 11:59 PM PST is 7:59 AM UTC
export const IS_USE_TARGET_DATE = false;

export const SHOW_CLOSE_ICON = false;
export const BANNER_TIMER_STORAGE_KEY = 'bannerTimeLeft';

// Sale type constants
export const BLACK_FRIDAY = 'black-friday';
export const CYBER_MONDAY = 'cyber-monday';
export const NEW_YEAR = 'new-year';
export const MEMORIAL_DAY = 'memorial-day';
export const LABOR_DAY = 'labor-day';

// Sales schedule configuration
// Define date ranges for special sales. Sales are checked in order.
// When no special sale is active, falls back to Flash Sale (default).
export const SALES_SCHEDULE = [
  {
    type: BLACK_FRIDAY,
    startDate: new Date('2025-11-08T08:00:00Z'), // Nov 12, 12:00 AM PST
    endDate: new Date('2025-12-01T07:59:00Z'), // Nov 30, 11:59 PM PST
  },
  {
    type: CYBER_MONDAY,
    startDate: new Date('2025-12-01T08:00:00Z'), // Dec 1, 12:00 AM PST
    endDate: new Date('2025-12-07T07:59:00Z'), // Dec 4, 11:59 PM PST
  },
  {
    type: NEW_YEAR,
    startDate: new Date('2025-12-22T08:00:00Z'), // Dec 22, 12:00 AM PST
    endDate: new Date('2026-01-06T07:59:00Z'), // Jan 5, 11:59 PM PST
  },
  {
    type: MEMORIAL_DAY,
    startDate: new Date('2026-05-22T07:00:00Z'), // May 22, 12:00 AM PDT (Fri)
    endDate: new Date('2026-05-27T07:00:00Z'), // May 27, 12:00 AM PDT (end of Tue market day)
  },
  {
    type: LABOR_DAY,
    startDate: new Date('2026-09-01T07:00:00Z'), // Sep 1, 12:00 AM PDT
    endDate: new Date('2026-09-10T07:00:00Z'), // Sep 10, 12:00 AM PDT
  },
];

// Determines which sale is currently active based on the current date/time
// Returns 'black-friday', 'cyber-monday', 'new-year', or null (for Flash Sale default)
export const getActiveSaleType = (): string | null => {
  const now = new Date();

  for (const sale of SALES_SCHEDULE) {
    if (now >= sale.startDate && now <= sale.endDate) {
      return sale.type;
    }
  }

  // No active special sale, return null for Flash Sale default
  return null;
};

// Sale configuration type
export interface SaleConfig {
  saleType: string | null;
  dealText: string;
  percentage: string;
  discountText: string;
  couponCode: string;
  buttonText: string;
  buttonTextBanner: string;
  targetDate: Date;
  timeDelay: number;
  showOnScroll: boolean;
}

// Centralized function to get current sale configuration
// This ensures Banner and PromoButton components always show the same sale
export const getCurrentSaleConfig = (): SaleConfig => {
  const saleType = getActiveSaleType();

  if (saleType === BLACK_FRIDAY) {
    return {
      saleType: BLACK_FRIDAY,
      dealText: BLACK_FRIDAY_DEAL_TEXT,
      percentage: BLACK_FRIDAY_PERCENTAGE,
      discountText: BLACK_FRIDAY_DISCOUNT_TEXT,
      couponCode: BLACK_FRIDAY_COUPON_CODE,
      buttonText: BLACK_FRIDAY_BUTTON_TEXT,
      buttonTextBanner: BLACK_FRIDAY_BUTTON_TEXT_BANNER,
      targetDate: BLACK_FRIDAY_TARGET_DATE,
      timeDelay: BLACK_FRIDAY_TIME_DELAY,
      showOnScroll: BLACK_FRIDAY_SHOW_ON_SCROLL,
    };
  }

  if (saleType === CYBER_MONDAY) {
    return {
      saleType: CYBER_MONDAY,
      dealText: CYBER_MONDAY_DEAL_TEXT,
      percentage: CYBER_MONDAY_PERCENTAGE,
      discountText: CYBER_MONDAY_DISCOUNT_TEXT,
      couponCode: CYBER_MONDAY_COUPON_CODE,
      buttonText: CYBER_MONDAY_BUTTON_TEXT,
      buttonTextBanner: CYBER_MONDAY_BUTTON_TEXT_BANNER,
      targetDate: CYBER_MONDAY_TARGET_DATE,
      timeDelay: CYBER_MONDAY_TIME_DELAY,
      showOnScroll: CYBER_MONDAY_SHOW_ON_SCROLL,
    };
  }

  if (saleType === MEMORIAL_DAY) {
    return {
      saleType: MEMORIAL_DAY,
      dealText: MEMORIAL_DAY_DEAL_TEXT,
      percentage: MEMORIAL_DAY_PERCENTAGE,
      discountText: MEMORIAL_DAY_DISCOUNT_TEXT,
      couponCode: MEMORIAL_DAY_COUPON_CODE,
      buttonText: MEMORIAL_DAY_BUTTON_TEXT,
      buttonTextBanner: MEMORIAL_DAY_BUTTON_TEXT_BANNER,
      targetDate: MEMORIAL_DAY_TARGET_DATE,
      timeDelay: MEMORIAL_DAY_TIME_DELAY,
      showOnScroll: MEMORIAL_DAY_SHOW_ON_SCROLL,
    };
  }

  if (saleType === NEW_YEAR) {
    return {
      saleType: NEW_YEAR,
      dealText: NEW_YEAR_DEAL_TEXT,
      percentage: NEW_YEAR_PERCENTAGE,
      discountText: NEW_YEAR_DISCOUNT_TEXT,
      couponCode: NEW_YEAR_COUPON_CODE,
      buttonText: NEW_YEAR_BUTTON_TEXT,
      buttonTextBanner: NEW_YEAR_BUTTON_TEXT_BANNER,
      targetDate: NEW_YEAR_TARGET_DATE,
      timeDelay: NEW_YEAR_TIME_DELAY,
      showOnScroll: NEW_YEAR_SHOW_ON_SCROLL,
    };
  }

  if (saleType === LABOR_DAY) {
    return {
      saleType: LABOR_DAY,
      dealText: LABOR_DAY_DEAL_TEXT,
      percentage: LABOR_DAY_PERCENTAGE,
      discountText: LABOR_DAY_DISCOUNT_TEXT,
      couponCode: LABOR_DAY_COUPON_CODE,
      buttonText: LABOR_DAY_BUTTON_TEXT,
      buttonTextBanner: LABOR_DAY_BUTTON_TEXT_BANNER,
      targetDate: LABOR_DAY_TARGET_DATE,
      timeDelay: LABOR_DAY_TIME_DELAY,
      showOnScroll: LABOR_DAY_SHOW_ON_SCROLL,
    };
  }

  // Default to Flash Sale
  return {
    saleType: null,
    dealText: DEAL_TEXT,
    percentage: PERCENTAGE,
    discountText: DISCOUNT_TEXT,
    couponCode: COUPON_CODE,
    buttonText: BUTTON_TEXT,
    buttonTextBanner: BUTTON_TEXT_BANNER,
    targetDate: IS_USE_TARGET_DATE ? TARGET_DATE : new Date(Date.now() + TIME_LEFT * 1000),
    timeDelay: TIME_DELAY,
    showOnScroll: true,
  };
};
